import React from "react";
import LocalShippingOutlinedIcon from "@material-ui/icons/LocalShippingOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import AutorizacionEgresoCard from "./AutorizacionEgresoCard";
import {
  ExitAuthorization,
  ExitAuthorizationGroup,
  GateControlKey,
  GateControlObservation,
} from "./transportAuthorizationTypes";

type AutorizacionEgresoGroupCardProps = {
  grupo: ExitAuthorizationGroup;
  isExpanded: boolean;
  onToggleExpand: (grupoId: string) => void;
  selectedAutorizacionId: string | null;
  onSelectAutorizacion: (auth: ExitAuthorization) => void;
  expandedAutorizacionId: string | null;
  onToggleExpandAutorizacion: (authId: string) => void;
  onReenviar: (authId: string) => void;
  onRegistrarPorOtroMedio: (authId: string) => void;
  onVerificarControl: (authId: string, controlId: GateControlKey) => void;
  controlObservations: Record<string, Partial<Record<GateControlKey, GateControlObservation>>>;
  onObservacionTextChange: (authId: string, controlId: GateControlKey, text: string) => void;
  onObservacionPhotoChange: (authId: string, controlId: GateControlKey, photo: File | null) => void;
  disabled?: boolean;
};

const AutorizacionEgresoGroupCard: React.FC<AutorizacionEgresoGroupCardProps> = ({
  grupo,
  isExpanded,
  onToggleExpand,
  selectedAutorizacionId,
  onSelectAutorizacion,
  expandedAutorizacionId,
  onToggleExpandAutorizacion,
  onReenviar,
  onRegistrarPorOtroMedio,
  onVerificarControl,
  controlObservations,
  onObservacionTextChange,
  onObservacionPhotoChange,
  disabled = false,
}) => {
  const count = grupo.authorizations.length;
  const cargados = grupo.authorizations.filter((a) => a.loaded).length;
  const vacios = count - cargados;

  return (
    <div className="transportAuthCard">
      <div
        className={`transportAuthCardHeaderArea ${
          isExpanded ? "transportAuthCardHeaderAreaSelected" : ""
        }`}
        onClick={() => onToggleExpand(grupo.id)}
      >
        <div className="transportAuthCardTop">
          <div className="transportAuthCardTitleGroup">
            <div className="transportAuthTitleBlock">
              <h4 className="transportAuthCardTitle">{grupo.title}</h4>
              <span className="transportAuthCardSubtitle">{grupo.subtitle}</span>
            </div>
          </div>
          <div className="transportAuthCardRight">
            <span className="transportEgresoGroupCountCapsule">
              {count} {count === 1 ? "autorización" : "autorizaciones"}
            </span>
            <ExpandMoreIcon
              style={{
                transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
                color: "#64748B",
              }}
            />
          </div>
        </div>

        <div className="transportAuthCardBottom">
          <LocalShippingOutlinedIcon fontSize="small" style={{ color: "#94A3B8" }} />
          <span className="transportAuthCardMetaText">
            {cargados} {cargados === 1 ? "cargado" : "cargados"} &nbsp;|&nbsp; {vacios}{" "}
            {vacios === 1 ? "vacío" : "vacíos"}
          </span>
        </div>
      </div>

      <div className={`transportAuthCardAccordionContent ${isExpanded ? "open" : ""}`}>
        <div className="transportAuthCardAccordionInner">
          <div className="transportEgresoGroupInner" onClick={(e) => e.stopPropagation()}>
            {grupo.authorizations.map((auth) => (
              <AutorizacionEgresoCard
                key={auth.id}
                autorizacion={auth}
                isSelected={selectedAutorizacionId === auth.id}
                isExpanded={expandedAutorizacionId === auth.id}
                onSelect={onSelectAutorizacion}
                onToggleExpand={onToggleExpandAutorizacion}
                onReenviar={onReenviar}
                onRegistrarPorOtroMedio={onRegistrarPorOtroMedio}
                onVerificarControl={onVerificarControl}
                observations={controlObservations[auth.id] ?? {}}
                onObservacionTextChange={onObservacionTextChange}
                onObservacionPhotoChange={onObservacionPhotoChange}
                disabled={disabled}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AutorizacionEgresoGroupCard;
